import { ContainerModule } from 'inversify';
import Dispatcher from '@framework/analytics-tracker/Sender/senders/SocketDispatcher';
import SocketDispatcher from '../Rpc/finsight-web/SocketDispatcher';

export const analyticsModule: ContainerModule = new ContainerModule((bind) => {
  bind(Dispatcher).toDynamicValue(({ container }) => container.get(SocketDispatcher)).inSingletonScope();
});
